export default __webpack_public_path__ + "static/media/profile-img.a502a485.jpg";